// Any broken cover/thumbnail image: try the original file once, then show a neutral placeholder instead of a broken icon.
const PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" fill="#27272a"/>' +
  '<circle cx="32" cy="32" r="14" fill="none" stroke="#71717a" stroke-width="3"/><circle cx="32" cy="32" r="3" fill="#71717a"/></svg>');

document.addEventListener("error", (e) => {
  const img = e.target;
  if (!(img instanceof HTMLImageElement) || img.dataset.fallback === "done") return;
  const src = img.currentSrc || img.src || "";
  if (!/\/api\/(media\/thumb|files\/public)/.test(src)) return;
  if (src.includes("/media/thumb") && !img.dataset.fallback) {
    const orig = new URL(src).searchParams.get("src");
    if (orig) {
      img.dataset.fallback = "orig";
      img.removeAttribute("srcset");
      img.src = orig.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${orig}` : orig;
      return;
    }
  }
  img.dataset.fallback = "done";
  img.removeAttribute("srcset");
  img.src = PLACEHOLDER;
}, true);
